import { Avatar, AvatarColors, ThemeColor } from "@deligoo/ui"
import clsx from "clsx"

import { Driver } from "@/types"

import cls from "./User.module.scss"

type UserProps = {
  name: string
  color: ThemeColor | keyof typeof AvatarColors
  subheader: React.ReactNode
  indicator?: "break"
  dotColor?: ThemeColor
  state?: Driver["state"]
  action?: React.ReactNode
  disabled?: boolean
  context?: "primary" | "secondary"
}

export const User = ({
  name,
  color,
  indicator,
  dotColor,
  subheader,
  action,
  disabled,
  context = "secondary",
}: UserProps) => {
  return (
    <div className={clsx(cls.user, context && cls[context], disabled && cls.disabled)}>
      <div className={cls.avatar}>
        <Avatar color={color} indicator={indicator} dotColor={dotColor}>
          {name}
        </Avatar>
      </div>

      <div className={cls.content}>
        <div className={cls.name}>{name}</div>
        {subheader}
      </div>

      {action && <div className={cls.action}>{action}</div>}
    </div>
  )
}
